module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/de.json
// module id = 563
// module chunks = 0